import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import SecuredReducer from "../../lib/keycloak/slice";
import AuthReducer from "../../pages/auth/slice";
import PaymentReducer from '../../pages/customer/payment/slice';
import CustomerReducer from "../../pages/customer/slice";
import InvoiceAmountReducer from "../../pages/invoicing/slice";
import UserReducer from "../../pages/user/slice";
import LayoutReducer from "../../ui/layout/slice";
import ObjectReducer from "../object/slice";

export const store = configureStore({
    reducer: {
        secured: SecuredReducer,
        layout: LayoutReducer,
        object: ObjectReducer,
        user: UserReducer,
        auth: AuthReducer,
        customer: CustomerReducer,
        payment: PaymentReducer,
        invoiceAmount: InvoiceAmountReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

